import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from '../../core/interfaces/cell-renderer.interface';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Customer Cell Renderer Component
 *
 * Reusable cell renderer for displaying customer information.
 * Shows customer code (bold) on first line and customer name on second line.
 *
 * Usage in ColDef:
 * ```typescript
 * {
 *   field: 'shipToExternalKeyCode',
 *   cellRenderer: CustomerCellRendererComponent
 * }
 * ```
 */
@Component({
  selector: "app-customer-cell-renderer",
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="text-content">
      <b class="f-10">{{ customerCode }}</b
      ><br />
      <span class="font-descrip">{{ customerName }}</span>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerCellRendererComponent
  implements CellRenderer<any, string>
{
  /**
   * Parameters from the grid containing the cell value and row data
   */
  @Input() params!: CellRendererParams<any, string>;

  /**
   * Get customer code from row data
   */
  get customerCode(): string {
    return this.params?.data?.shipToExternalKeyCode ?? "-";
  }

  /**
   * Get customer name from row data
   */
  get customerName(): string {
    return this.params?.data?.shipToName ?? "-";
  }
}
